import styled, { css, keyframes } from 'styled-components'

export const fadeInKeyframe = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`

export function fadeIn (duration = '300ms') {
  return css`
    opacity: 0.5;
    animation: forwards ${fadeInKeyframe} ${duration} ease-in;
  `
}

export const FadeIn = styled.div`
  ${fadeIn()}
`
